import * as THREE from 'three'
import Scene from './Scene'
import Model from '@/objects/Model'
import config from '@/config/selectStory'
import store from '@/store'

const clock = new THREE.Clock()

export default class SelectStoryScene extends Scene {
  name = 'SelectStoryScene'

  constructor (stage) {
    super()
    this.stage = stage
  }

  createPlayer () {
    this.player = new Model(store.getters.playerModel)
    this.player.position.copy(config.player)
    this.player.setShadow(3, config.scene.shadow)
  }

  createCharacter () {
    this.character = new Model(store.getters.characterModel)
    this.character.position.copy(config.character)
    this.character.setShadow(3, config.scene.shadow)
  }

  start () {
    const { background, fog } = config.scene
    const { x, y, z } = config.camera

    this.createPlayer()
    this.createCharacter()

    this.stage.add(this.player)
    this.stage.add(this.character)

    this.stage.changeBackground(background, 1000)
    this.stage.changeFogColor(fog.color, 1000)
    this.stage.changeFogDistance(fog.near, fog.far, 1000)
    this.stage.changeCameraPosition(x, y, z, 1000)

    this.stage.followMouse = false
  }

  stop () {
    this.stage.remove(this.player)
    this.stage.remove(this.character)

    this.player = null
    this.character = null
    this.stage.followMouse = true
  }

  update () {
    const delta = clock.getDelta()
    this.player.update(delta)
    this.character.update(delta)
  }
}
